/** @format */

import { computed, ref } from "vue";

/**
 * Reactive global loading state — the modern replacement for the old
 * `globalLoad` event-bus channel.
 *
 * The axios interceptors call `startLoading()` when a request begins and
 * `stopLoading()` when one settles; `App.vue` reads `isLoading` to toggle the
 * overlay. An in-flight pulse counter (clamped at 0) means concurrent requests
 * can't hide the overlay early or wedge it open.
 */
const inFlight = ref(0);

export function startLoading(): void {
  inFlight.value += 1;
}

export function stopLoading(): void {
  inFlight.value = Math.max(0, inFlight.value - 1);
}

export function useLoading() {
  const isLoading = computed(() => inFlight.value > 0);
  return { isLoading, startLoading, stopLoading };
}
